const Images = {
  emptyAgeRange: require('../assets/empty-barchart.svg'),
  emptyDemo: require('../assets/empty-demo.svg'),
};

export default Images;



// WEBPACK FOOTER //
// ./src/common/themes/Images.js